'use strict';

const easeOutCubic = "cubic-bezier(0.215, 0.61, 0.355, 1)";
const easeOutQuart = "cubic-bezier(0.165, 0.84, 0.44, 1)";
const easeOutCirc = "cubic-bezier(0.075, 0.82, 0.165, 1)";
const easeInOutCubic = "cubic-bezier(0.645, 0.045, 0.355, 1)";

exports.easeInOutCubic = easeInOutCubic;
exports.easeOutCirc = easeOutCirc;
exports.easeOutCubic = easeOutCubic;
exports.easeOutQuart = easeOutQuart;
//# sourceMappingURL=timing.cjs.map
